export enum SecurityGroupAccessType {
  UserProfile,
  Role,
}
export enum SecurityGroupDialogTarget {
  UserProfile,
  Access,
}
